import { ImageLoaderProps } from 'next/image';

export default function bcCdnImageLoader({ src, width }: ImageLoaderProps): string {
  if (src.includes('{:size}')) {
    return src.replace('{:size}', `${width}w`);
  }

  return src.replace(/\/stencil\/(?:\d+w|original)\//, `/stencil/${width}w/`);
}
